import { Text } from '@mantine/core'

import * as Types from '../../declarations'
import SectionHeader from './components/SectionHeader'

interface Props {
	trip: Types.DB.Models.TripAttributes
}

const SummitView = ({
	trip: {
		name,
		jsonData: { route },
	},
}: Props) => {
	const summit = (route?.locations ?? []).find(({ type }) => type === 'summit')

	if (!summit) return <></>

	return (
		<div
			id="summit-view-visualiation-wrapper"
			className="spacing-between-sections-above"
		>
			<SectionHeader
				title={`${name} Summit view`}
				section={Types.App.DataTypes.FeedbackSection.SUMMIT_VIEW}
			/>
			<Text>
				What you can see from the summit of {name}. Click and pan around the map
				to explore, and zoom in/out to see the names of neighbouring mountains.
			</Text>
			<iframe
				src={`https://www.peakfinder.org/embed/?lat=${summit.latitude}&lng=${summit.longitude}&fov=110`}
				frameBorder="0"
				width="100%"
				height="570"
				name="peakfinder"
				title="peak finder summit view"
			>
				{/* <p>Your Browser does not support iFrames.</p> */}
			</iframe>
		</div>
	)
}

export default SummitView
